import React from "react";
import { Link } from "react-router-dom";
import {
  Table,
  Download,
  PlusCircle,
  Target,
  Settings,
  Database,
  Network,
} from "lucide-react";

function Home() {
  return (
    <div className="px-4 pt-4 text-center">
      <h1 className="mb-4 mt-0 text-4xl font-bold dark:text-white">
        Welcome to Globe Data
      </h1>
      <p className="text-gray-600 dark:text-white">
        Explore your database tables and data
      </p>
      <div className="mt-8 max-w-md mx-auto space-y-4">
        <Link
          to="/tables"
          className="flex items-center gap-3 bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors duration-200"
        >
          <Table size={20} />
          <span>Explore Tables</span>
        </Link>

        <Link
          to="/import-export"
          className="flex items-center gap-3 bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors duration-200"
        >
          <Download size={20} />
          <span>Import / Export</span>
        </Link>

        <Link
          to="/gd-tools"
          className="flex items-center gap-3 bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors duration-200"
        >
          <Settings size={20} />
          <span>Globe Data Tools</span>
        </Link>

        <Link
          to="/dwh-schemas"
          className="flex items-center gap-3 bg-purple-500 text-white px-6 py-3 rounded-lg hover:bg-purple-600 transition-colors duration-200"
        >
          <Network size={20} />
          <span>DWH Schemas</span>
        </Link>
      </div>
    </div>
  );
}

export default Home;
